/**
 * What a relationship on the collector list is CALLED, in the reader's words.
 *
 * Keyed by the `kind` strings `ondo.my_contact_edges()` emits. A kind with no
 * entry here falls back to itself rather than blanking the row — a verb added
 * in SQL must not be a compile error in a client, which is the same argument
 * `Contact.kinds` is a `string[]` and not a union.
 *
 * IT LIVES IN @ondo/shared BECAUSE THE SERVER WRITES THESE WORDS NOW. OND-67
 * moved the collector-list export off the browser, and the exported file's
 * "Type" column is this label — so if the map stayed in
 * `apps/web-frontend/src/gallery/contacts.constants.ts` the API would need a
 * second copy, and the day a kind was added to one the file and the screen
 * would disagree about what the same row is. `contacts.constants.ts` reads
 * this one.
 *
 * NO STATUS WORDS. Every label here describes a relationship the database can
 * prove. There is no "prospect" and no "VIP", for the reason
 * `contacts.constants.ts` gives: a status column would be a stored opinion
 * wearing a fact's clothes.
 */
export const CONTACT_KIND_LABELS = {
    consignor: "Consignor",
    seller: "Sold for them",
    buyer: "Buyer",
    agent: "Agent",
    appointer: "Appointed you",
    reseller: "Resold your work",
    resale_gallery: "Ran a resale",
    artist: "Artist owed",
    asked_to_verify: "Asked to verify",
    asked_us: "Asked you to verify",
    affiliation: "Affiliation",
    added: "Added by you",
};
/**
 * 'Consignor', 'Sold for them' — one relationship in the reader's words.
 *
 * Falls back to the raw kind rather than blanking or dropping it. A verb this
 * build has never heard of is still true about the reader's own rows, and
 * hiding it would make the row quietly wrong instead of merely unpolished.
 */
export function describeContactKind(kind) {
    return CONTACT_KIND_LABELS[kind] ?? kind;
}
//# sourceMappingURL=contacts.js.map